module.exports = __webpack_public_path__ + "media/images/icon__dhi--rb-gray@2x-3e15c35d4eea5377510dc4b6436bb7b6.png";